import { render, staticRenderFns } from "./GymVideoDurationBadge.vue?vue&type=template&id=520847e4&scoped=true&"
import script from "./GymVideoDurationBadge.vue?vue&type=script&lang=js&"
export * from "./GymVideoDurationBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520847e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520847e4')) {
      api.createRecord('520847e4', component.options)
    } else {
      api.reload('520847e4', component.options)
    }
    module.hot.accept("./GymVideoDurationBadge.vue?vue&type=template&id=520847e4&scoped=true&", function () {
      api.rerender('520847e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/Includes/Badges/GymVideoDurationBadge.vue"
export default component.exports